/**
 * Money value (amount + currency)
 */
export default class Money {
  readonly amount: number;
  readonly currency: string;

  /**
   * Constructs the money object from JSON
   * @param json {any} JSON representation of Money object
   * @param json.amount {number} Amount in cents
   * @param json.currency {string}
   */
  constructor(json: any) {
    this.amount = json.amount as number;
    this.currency = json.currency ? json.currency : 'EUR';
  }

  /**
   * Returns a formatted string
   */
  format(): string {
    return Money.format(this.amount, this.currency);
  }

  static format(amount: number, currency: string): string {
    const opts = {
      currency: currency,
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
      style: 'currency',
    };
    const locale = navigator.language ? navigator.language : 'de-DE';
    return Intl.NumberFormat(locale, opts).format(amount);
  }
}
